module.exports = __webpack_public_path__ + "static/media/illustrator.35db0179.svg";